import { selfAxios } from "../../../../../axios/selfAxios.js";
async function reqDelivery(params) {
  const {
    data: { data }
  } = await selfAxios.post("/bsplatform/carrier/delivery/method", params, { _cache: true });
  return data;
}
export { reqDelivery };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/bsplatform/carrier/delivery/method/post.js